import {
  Card,
  FormLayout,
  Layout,
  Loading, SkeletonBodyText,
  SkeletonDisplayText,
  SkeletonPage,
  TextContainer
} from "@shopify/polaris";
import { CsI18n } from "../../shared/csI18n/csI18n";
import React from "react";

const PrivacySkeleton = () => {
  return (
    <SkeletonPage title={CsI18n.t("Privacy policy")} fullWidth>
      <Loading />
      <Layout>
        <Layout.AnnotatedSection title={CsI18n.t("privacy.annotate.title.privacy")}
                                 description={CsI18n.t('privacy.annotate.desc.privacy')}>
          <Card sectioned>
            <FormLayout>
              <TextContainer>
                <SkeletonDisplayText size={"medium"} />
                <SkeletonBodyText lines={3} />
                <SkeletonBodyText lines={3} />
              </TextContainer>
            </FormLayout>
          </Card>
        </Layout.AnnotatedSection>

        <Layout.AnnotatedSection description={CsI18n.t("privacy.annotate.desc.partners")}>
          <Card sectioned>
            <FormLayout>
              <TextContainer>
                <SkeletonDisplayText size={"medium"} />
                <SkeletonBodyText lines={3} />
                <SkeletonBodyText lines={3} />
              </TextContainer>
            </FormLayout>
          </Card>
        </Layout.AnnotatedSection>

        <Layout.AnnotatedSection description={CsI18n.t("privacy.annotate.desc.marketing")}>
          <Card sectioned>
            <FormLayout>
              <TextContainer>
                <SkeletonDisplayText size={"medium"} />
                <SkeletonBodyText lines={3} />
                <SkeletonBodyText lines={3} />
              </TextContainer>
            </FormLayout>
          </Card>
        </Layout.AnnotatedSection>

        <Layout.AnnotatedSection description={CsI18n.t("privacy.annotate.desc.cookies")}>
          <Card sectioned>
            <FormLayout>
              <TextContainer>
                <SkeletonDisplayText size={"medium"} />
                <SkeletonBodyText lines={3} />
                <SkeletonBodyText lines={3} />
              </TextContainer>
            </FormLayout>
          </Card>
        </Layout.AnnotatedSection>
      </Layout>
    </SkeletonPage>
  );
};

export default PrivacySkeleton;